<template>
  <div class="flex column" style="align-items: center">
    <div style="margin: auto">
      <barcode :value="+coupon.barcode"/>
    </div>
    <h4 style="text-align: center" class="heading mb4">{{ $t("cms.coupon.BarcodeModalTitle") }}</h4>
    <hr style="width: 250px;"/>
    <p
      class="mb4 mt2 gray"
      style="text-align: center"
    >{{ $t("cms.coupon.BarcodeModalSubtitle") }}</p>
  </div>
</template>
<script>
import Barcode from './Barcode.vue';

export default {
  name: 'BarcodeModal',
  components: { Barcode },
  props: {
    coupon: { type: Object, required: true },
  },
};
</script>
